import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useContents } from "../hooks/useContents";
import { AppHeader } from "../components/layout/AppHeader";
import { Sidebar } from "../components/layout/Sidebar";
import { ContentsList } from "../components/contents/ContentsList";
import { NewFolderModal } from "../components/modals/NewFolderModal";
import { FilePreviewModal } from "../components/modals/FilePreviewModal";
import type { Crumb, FileDTO } from "../lib/api/types";

const HOME_CRUMB: Crumb = { id: "root", name: "Home" };

export function DashboardPage() {
  const { folderId: folderIdParam } = useParams();
  const folderId = folderIdParam ?? null;
  const navigate = useNavigate();

  const [newFolderOpen, setNewFolderOpen] = useState(false);
  const [previewFile, setPreviewFile] = useState<FileDTO | null>(null);

  // Shares the query cache with ContentsList (same key → single fetch).
  const { data } = useContents(folderId);
  const crumbs = data?.breadcrumb ?? [HOME_CRUMB];

  const openFolder = (id: string) => navigate(`/folder/${id}`);

  return (
    <div className="flex min-h-full">
      <Sidebar />

      <div className="flex min-h-full min-w-0 flex-1 flex-col">
        <AppHeader folderId={folderId} crumbs={crumbs} onNewFolder={() => setNewFolderOpen(true)} />

        <main className="mx-auto w-full max-w-5xl flex-1 px-gutter py-6">
          <ContentsList
            folderId={folderId}
            onOpenFolder={openFolder}
            onOpenPreview={(file) => setPreviewFile(file)}
          />
        </main>

        <NewFolderModal
          open={newFolderOpen}
          parentId={folderId}
          onClose={() => setNewFolderOpen(false)}
        />

        <FilePreviewModal file={previewFile} onClose={() => setPreviewFile(null)} />
      </div>
    </div>
  );
}
